  (function () {
    if (window.__mnmPdp) return; window.__mnmPdp = true;
    var root = document.querySelector('[data-mnm-sticky]');
    if (!root) return;
    var basePrice = Number(root.dataset.price) || 0;
    var dispatchText = root.dataset.dispatch || 'Ships in 24 hours';
    var rupees = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };
    var $ = function (s, r) { return (r || document).querySelector(s); };
    var form = $('.product__info-container form[data-type="add-to-cart-form"]');
    var submitBtn = form && form.querySelector('.product-form__submit');
    var addon = $('[data-mnm-addon]');
    var giftToggle = $('[data-mnm-gift-toggle]');
    var giftNote = $('[data-mnm-gift]');

    function total() { return basePrice +(addon && addon.checked ? Number(addon.dataset.price) : 0); }
    function label() {
      if (!submitBtn || submitBtn.disabled) return;
      var span = submitBtn.querySelector('span');
      var text = 'Add to cart · ' + rupees(total());
      if (span && span.textContent.trim() !== text) span.textContent = text;
      var sp = $('[data-mnm-sticky-price]'); if (sp) sp.textContent = rupees(total());
    }
    if (addon) addon.addEventListener('change', label);
    label();

    function openCart() {
      if (window.mnmCart) { return Promise.resolve(window.mnmCart.open()); }
      return fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && s['cart-icon-bubble']) {
          var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble'];
          var inner = tmp.querySelector('.shopify-section') || tmp; el.innerHTML = inner.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (el) el.click();
      }).catch(function () { window.location.href = '/cart'; });
    }
    function add(items, btn) {
      var old = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(openCart)
        .catch(function (e) { alert((e && (e.description || e.message)) || 'Could not add to cart. Please try again.'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = old; label(); } });
    }
    function mainItems() {
      var id = form.querySelector('input[name="id"]').value;
      var qtyEl = form.querySelector('input[name="quantity"]') || $('.product__info-container input[name="quantity"]');
      var item = { id: Number(id), quantity: qtyEl ? Math.max(1, Number(qtyEl.value) || 1) : 1 };
      if (giftToggle && giftToggle.checked && giftNote && giftNote.value.trim()) item.properties = { 'Gift note': giftNote.value.trim() };
      var items = [item];
      if (addon && addon.checked) items.push({ id: Number(addon.dataset.mnmAddon), quantity: 1 });
      return items;
    }
    function onAdd(e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (submitBtn && submitBtn.disabled) return;
      add(mainItems(), submitBtn);
    }
    if (form) {
      // Cart apps listen for clicks on the Add to cart button, so catch the click first (window, capture phase).
      window.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.product-form__submit');
        if (b && b === submitBtn) onAdd(e);
      }, true);
      form.addEventListener('submit', onAdd, true);
    }
    var up = $('[data-mnm-upgrade]');
    if (up) up.addEventListener('click', function () { add([{ id: Number(up.dataset.mnmUpgrade), quantity: 1 }], up); });

    if (giftToggle) giftToggle.addEventListener('change', function () {
      var w = $('[data-mnm-gift-wrap]'); w.hidden = !giftToggle.checked; if (giftToggle.checked && giftNote) giftNote.focus();
    });
    if (giftNote) giftNote.addEventListener('input', function () { var c = $('[data-mnm-gift-count]'); if (c) c.textContent = giftNote.value.length; });

    var del = $('[data-mnm-delivery]');
    if (del) {
      var input = del.querySelector('input'), out = del.querySelector('.mnm-delivery__out');
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var check = function () {
        var pin = (input.value || '').replace(/\D/g, '');
        if (!/^[1-9]\d{5}$/.test(pin)) { out.className = 'mnm-delivery__out is-error'; out.textContent = 'Please enter a valid 6-digit pincode.'; return; }
        var a = new Date(), b = new Date(); a.setDate(a.getDate() + 5); b.setDate(b.getDate() + 7);
        out.className = 'mnm-delivery__out';
        out.innerHTML = 'Delivering to ' + pin + ' · Estimated <strong>' + fmt(a) + ' – ' + fmt(b) + '</strong><br><span class="mnm-muted">' + dispatchText + ' (Mon–Sat). Delivered in 5–7 days.</span>';
        try { localStorage.setItem('mnm_pin', pin); } catch (e) {}
      };
      del.querySelector('button').addEventListener('click', check);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      try { var saved = localStorage.getItem('mnm_pin'); if (saved) { input.value = saved; check(); } } catch (e) {}
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-mnm-reviews]'); if (!a) return;
      var t = document.getElementById('mnm-reviews') || document.querySelector('.jdgm-widget, [class*="jdgm-rev-widg"], [class*="judge"]');
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    var sticky = $('[data-mnm-sticky]');
    if (sticky && submitBtn) {
      $('[data-mnm-sticky-btn]').addEventListener('click', function () { if (!submitBtn.disabled) add(mainItems(), this); });
      var io = new IntersectionObserver(function (en) {
        var off = !en[0].isIntersecting;
        sticky.classList.toggle('is-on', off); sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = off ? 0 : -1;
      });
      io.observe(submitBtn);
    }
  })();
  